/**
 * pdp-v2.js — PDP v2 Entry Point
 * ================================
 * Deferred entry point. Loaded via:
 *   <script src="{{ 'pdp-v2.js' | asset_url }}" defer></script>
 * in pdp-v2-product.liquid.
 *
 * Each Web Component is defined in its own asset file and loaded alongside
 * this file. This entry point documents the component registry and provides
 * shared utilities available to all pdp-v2 modules.
 *
 * Components registered elsewhere:
 *   pdp-v2-sticky-atc    → assets/pdp-v2-sticky-atc.js
 *   pdp-v2-tabs          → assets/pdp-v2-tabs.js
 *   pdp-v2-system-cart   → assets/pdp-v2-system-cart.js
 *   pdp-v2-video-facade  → assets/pdp-v2-video-facade.js
 */

/* ============================================================
   Shared utilities
   ============================================================ */

/**
 * Format a price integer (Shopify cents) to a locale string.
 * @param {number} cents — price in Shopify's integer cents format
 * @param {string} [currency='USD']
 * @returns {string} — e.g. "$349.99"
 */
window.pdpV2FormatMoney = function formatMoney(cents, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(cents / 100);
};

/**
 * Open the theme's cart drawer if it exists, otherwise navigate to /cart.
 * Matches the existing theme's drawer open pattern.
 */
window.pdpV2OpenCart = function openCart() {
  // The Motion/Archetype theme listens for the 'cart:open' custom event on document.
  // See assets/theme.js: document.addEventListener('cart:open', this.open.bind(this))
  document.dispatchEvent(new CustomEvent('cart:open'));
};

/**
 * Size chart modal — delegated open/close handler.
 * Supports [data-open-modal="<id>"], [data-close-modal], and backdrop clicks.
 */
document.addEventListener('click', function(e) {
  var opener = e.target.closest('[data-open-modal]');
  if (opener) {
    var modal = document.getElementById(opener.dataset.openModal);
    if (modal && modal.showModal) modal.showModal();
    return;
  }
  var closer = e.target.closest('[data-close-modal]');
  if (closer) {
    var dialog = closer.closest('dialog');
    if (dialog) dialog.close();
    return;
  }
  if (e.target.tagName === 'DIALOG') {
    e.target.close();
  }
});

/**
 * Product Recommendations — progressive enhancement.
 * Finds any [data-url] container within .pdp-v2-recommendations, fetches the
 * section HTML via Shopify's recommendations API, and injects the result.
 * This keeps recommendations out of the critical render path.
 */
document.addEventListener('DOMContentLoaded', function() {
  var grid = document.querySelector('.pdp-v2-recommendations__grid[data-url]');
  if (!grid) return;

  fetch(grid.dataset.url)
    .then(function(res) { return res.text(); })
    .then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('.pdp-v2-recommendations__grid');
      if (newGrid && newGrid.children.length > 0) {
        grid.innerHTML = newGrid.innerHTML;
      }
    })
    .catch(function() { /* silently fail — section simply stays empty */ });
});

/**
 * Reposition size chart trigger to sit inline with the Size variant label.
 * Builds a flex row: [Size label] [Size Chart button] above the size buttons.
 */
document.addEventListener('DOMContentLoaded', function() {
  var triggerWrap = document.querySelector('.pdp-v2-size-chart-trigger-wrap');
  if (!triggerWrap) return;

  var sizeLabel = null;
  document.querySelectorAll('.variant__label').forEach(function(el) {
    if (/size/i.test(el.textContent.trim())) sizeLabel = el;
  });
  if (!sizeLabel) return;

  var variantWrapper = sizeLabel.closest('.variant-wrapper');
  if (!variantWrapper) return;

  var row = document.createElement('div');
  row.className = 'pdp-v2-size-label-row';
  variantWrapper.insertBefore(row, sizeLabel);
  row.appendChild(sizeLabel);
  row.appendChild(triggerWrap);
});
